import { send } from '@actual-app/core/platform/client/connection';
import { q } from '@actual-app/core/shared/query';

import { aqlQuery } from '#queries/aqlQuery';

import { gruposMismoComercio } from './mismoComercioLogica';
import type { GrupoComercio, MovimientoComercio } from './mismoComercioLogica';

/**
 * Los grupos «mismo comercio» de unos movimientos recién traídos (por id):
 * lee esos movimientos y el historial de sus comercios. Sin traspasos ni
 * movimientos partidos.
 */
export async function buscarGruposMismoComercio(
  ids: string[],
): Promise<GrupoComercio[]> {
  if (ids.length === 0) {
    return [];
  }
  const { data: nuevos } = (await aqlQuery(
    q('transactions')
      .filter({ id: { $oneof: ids }, is_parent: false, transfer_id: null })
      .select(['id', 'payee', 'category']),
  )) as { data: MovimientoComercio[] };
  const comercios = [
    ...new Set(
      nuevos.filter(m => m.category == null && m.payee).map(m => m.payee),
    ),
  ];
  if (comercios.length === 0) {
    return [];
  }
  const { data: anteriores } = (await aqlQuery(
    q('transactions')
      .filter({
        payee: { $oneof: comercios },
        category: { $ne: null },
        is_parent: false,
        transfer_id: null,
      })
      .select(['id', 'payee', 'category']),
  )) as { data: MovimientoComercio[] };
  return gruposMismoComercio(nuevos, anteriores);
}

/**
 * Pone su categoría a los movimientos de esos grupos, sin aprobarlos: siguen
 * esperando el visto bueno en «Por revisar». Se deshace con un solo
 * «Deshacer». Devuelve cuántos ha colocado.
 */
export async function colocarMismoComercio(
  grupos: GrupoComercio[],
): Promise<number> {
  const updated = grupos.flatMap(g =>
    g.ids.map(id => ({ id, category: g.categoria })),
  );
  if (updated.length > 0) {
    await send('transactions-batch-update', { updated });
  }
  return updated.length;
}
